module.exports = __webpack_public_path__ + "img/gonetwork2_icon9.99314756.png";